import {Component, Input, OnInit} from '@angular/core';
import {BranchAfarmStruct} from "./AfarmStruct";
import {BranchMeasurement} from "../../CardStruct";
import {VariableValue} from "../../../variableDataBase/VariableValue";
import {sprintf} from "sprintf-js";
import {VariableDataBase} from "../../../variableDataBase/variable-data-base.service";

@Component({
  selector: 'app-branch-type-afarm-overview',
  templateUrl: './branch-type-afarm-overview.component.html',
  styleUrls: ['./branch-type-afarm-overview.component.css']
})
export class BranchTypeAfarmOverviewComponent implements OnInit {
  @Input() branchAfarmOverview: BranchAfarmStruct | undefined;

  temperature_measurement:      &VariableValue = new VariableValue();
  temperature_setpoint:         &VariableValue = new VariableValue();
  rv_abs_product:               &VariableValue = new VariableValue();
  rv_abs_outside:               &VariableValue = new VariableValue();
  department_status:            &VariableValue = new VariableValue();
  treatment_status:             &VariableValue = new VariableValue();
  channel_temperature:          &VariableValue = new VariableValue();
  hatch_position:               &VariableValue = new VariableValue();
  hours_hatchopen_today:        &VariableValue = new VariableValue();
  co2_measurement:              &VariableValue = new VariableValue();


  GetValue(variable: VariableValue) : string
  {
    if(variable.IsInvalid())
      return "NaN";
    return sprintf("%5.1f", variable.val / 1);
  }

  GetValueAsHours(variable: VariableValue) : string
  {
    if(variable.IsInvalid())
      return "Na:aN";
    var time = variable.val * 100;

    return sprintf("%d hh:mm", time);
  }

  constructor(private variableDB: VariableDataBase) { }

  ngOnInit(): void {
    if (this.branchAfarmOverview) {
      this.temperature_measurement = this.variableDB.AddValueByReference(this.branchAfarmOverview.temperature_measurement.variable.id);
      this.temperature_setpoint = this.variableDB.AddValueByReference(this.branchAfarmOverview.temperature_setpoint.variable.id);
      this.rv_abs_product = this.variableDB.AddValueByReference(this.branchAfarmOverview.rv_abs_product.variable.id);
      this.rv_abs_outside = this.variableDB.AddValueByReference(this.branchAfarmOverview.rv_abs_outside.variable.id);
      this.treatment_status = this.variableDB.AddValueByReference(this.branchAfarmOverview.treatment_status.variable.id);
      this.department_status = this.variableDB.AddValueByReference(this.branchAfarmOverview.department_status.variable.id);
      this.channel_temperature = this.variableDB.AddValueByReference(this.branchAfarmOverview.channel_temperature.variable.id);
      this.hatch_position = this.variableDB.AddValueByReference(this.branchAfarmOverview.hatch_position.variable.id);
      this.hours_hatchopen_today = this.variableDB.AddValueByReference(this.branchAfarmOverview.hours_hatchopen_today.variable.id);
      this.co2_measurement = this.variableDB.AddValueByReference(this.branchAfarmOverview.co2_measurement.variable.id);
    }
  }

}
